import React, { Component } from 'react'
import './PackSelector.css';
import numeral from 'numeral';
import { VariationsSelector_variations_boxes } from '../../../Global_Layouts/VariationsSelector/VariationsSelector';
import { SHIPPING_OPTIONS } from '../ShippingTypeSelector/ShippingTypeSelector';


export default class PackSelector extends Component {

  render() {
    const { shoppingMoreThanOne, hidePackOne, hideSummaryTable, ProductData, getSelectedPackData, getSelectedVariants, selectedPackId, selectedPackData, selectedVariants} = this.props
    return (
      <div>
        {ProductData.comodin_packs.map((packData, packIndex) =>
            hidePackOne===true && packIndex===0 && shoppingMoreThanOne===false?
            null
            :
            <PackSelectorBox selectedVariants={selectedVariants} getSelectedVariants={getSelectedVariants} ProductData={ProductData} packData={packData} packIndex={packIndex} getSelectedPackData={getSelectedPackData} selectedPackId={selectedPackId}/>
        )}

        {/* {hideSummaryTable===true?
        null
        :
        <PackSelectorSummaryTable selectedPackData={selectedPackData}/>
        } */}
      </div>
    )
  }
}

class PackSelectorBox extends Component {
  render() {
    const {ProductData, packData, packIndex, getSelectedPackData, getSelectedVariants, selectedPackId, selectedVariants} = this.props

    return (
      <div className={selectedPackId.toString()===packIndex.toString()?"PackSelectorBox_selected":"PackSelectorBox"} onClick={(e)=>getSelectedPackData(e, packData)} id={packIndex.toString()}>
        <div className='d-flex' id={packIndex.toString()}>
          <div id={packIndex.toString()} className='PackSelectorBox_pack_img'>
              <img id={packIndex.toString()} src={ProductData.comodin_main_img_src.file_src} alt="" /></div>
          <div id={packIndex.toString()} className='PackSelectorBox_pack_data'>
              <div className='PackSelectorBox_pack_data_title' id={packIndex.toString()}>{packData.pack_title}</div>
              <div className='PackSelectorBox_pack_data_label' id={packIndex.toString()}>{packData.pack_label}</div>
          </div>
          <div id={packIndex.toString()} className='PackSelectorBox_pack_prices'>
              <div className='PackSelectorBox_pack_prices_price' id={packIndex.toString()}>{numeral(packData.price).format('$ 0,0[.]00')}</div>
              {packData.price!==packData.comparative_price?
              <div className='PackSelectorBox_pack_prices_comparative_price' id={packIndex.toString()}>{numeral(packData.comparative_price).format('$ 0,0[.]00')}</div>
              :null}
          </div>
        </div>



        {ProductData.productWithVariations === "SI"?
          packData.units.map(unit=>
            <PackSelectorBox_variants selectedVariants={selectedVariants} getSelectedVariants={getSelectedVariants} unit={unit} selectedPackId={selectedPackId} ProductData={ProductData} id={packIndex.toString()} />  
            // <div style={{transform:"scale(0.8)"}}>
            //   <VariationsSelector_variations_boxes selectedVariants={selectedVariants} getSelectedVariants={getSelectedVariants} unit={unit} selectedPackId={selectedPackId} ProductData={ProductData} id={packIndex.toString()} />  
            // </div>
            )
        :null}

        

        <div>

        </div>
      </div>
    )
  }
}


class PackSelectorBox_variants extends Component {
  render() {
    const {id, ProductData, selectedPackId, getSelectedVariants, unit, selectedVariants} = this.props
    
    if(selectedVariants[0]!==undefined){

      return (
          <div className='PackSelectorBox_variants d-flex' id={id}>
              {selectedPackId===id?
                ProductData.productOptions.map((variantData, i) =>
  
                  <div className='PackSelectorBox_variant_box'>
                    <div className='PackSelectorBox_variants_label' id={id}>{variantData.name}</div>
                    <select onChange={(e)=>getSelectedVariants(e, unit, i)} className='PackSelectorBox_variants_select' name="" id={id}>
                      
                      {variantData.values.map((option, index)=>
                        variantData.option_is_active[index] ?
                        <option selected={selectedVariants[unit]["variant"+i]===option?true:false} value={option+"@"+index}>{option}</option>
                        :
                        null
                      )}

                    </select>
                  </div>
  
                )
              :null}
          </div>
      )
    }

  }
}




// class PackSelectorSummaryTable extends Component {
//     render() {
//       const {selectedPackData} = this.props
  
//       return (
//         <div className='PackSelectorSummaryTable'>
//             <div className='PackSelectorSummaryTable_item'>
//                 <div className='PackSelectorSummaryTable_item_label'>Subtotal</div>
//                 <div className='PackSelectorSummaryTable_item_value'>{numeral(selectedPackData.comparative_price).format('$ 0,0[.]00')}</div>
//             </div>
            
//             {selectedPackData.discount>0?
//                 <div className='PackSelectorSummaryTable_item'>
//                     <div className='PackSelectorSummaryTable_item_label'>Descuento 🏷</div>
//                     <div style={{color:"red"}} className='PackSelectorSummaryTable_item_value'>{numeral(selectedPackData.discount).format('$ 0,0[.]00')}</div>
//                 </div>
//             :null}

//             <div className='PackSelectorSummaryTable_item_total'>
//                 <div className='PackSelectorSummaryTable_item_label_total'>Total</div>
//                 <div className='PackSelectorSummaryTable_item_value_total'>{numeral(selectedPackData.comparative_price - selectedPackData.discount).format('$ 0,0[.]00')}</div>
//             </div>
//         </div>
//       )
//     }
//   }

// ESPECIAL FOR CARTS
export class PackSelectorSummaryTable extends Component {
  calculateTotals = () => {
    
      const { selectedPackData, cartItems, free_shipping, shipping_cost, bulk_unit_discount, units, min_qty_to_get_bulk_discount, shipping_type_code } = this.props;

      let shipping_type_code_cost = SHIPPING_OPTIONS.find(option => option.code === shipping_type_code)?.price || 0;

      // let subtotal = selectedPackData.comparative_price; // Inicializa el subtotal con el precio comparativo del pack seleccionado actualmente
      let subtotal = 0; // Inicializa el subtotal con el precio comparativo del pack seleccionado actualmente
      // let totalDiscount = selectedPackData.discount??0; // Inicializa el total de descuentos con el descuento del pack seleccionado actualmente
      let totalDiscount = 0; // Inicializa el total de descuentos con el descuento del pack seleccionado actualmente

      // Sumar los valores de cada item en cartItems
      console.log("cartItems en PackSelectorSummaryTable:", cartItems);
      cartItems?.forEach(item => {
          subtotal += item?.selectedPackData?.comparative_price; // Suma los precios comparativos
          totalDiscount += item?.selectedPackData?.discount??0; // Suma los descuentos
      });


      // const additionalDiscounts = (free_shipping? shipping_cost : 0) + totalDiscount>0? 0 : ((units>=min_qty_to_get_bulk_discount)? (bulk_unit_discount*(units-1)) : 0)



      const def_units = units === 2? 1 : units; // Ajuste para calcular correctamente el descuento por unidad
      // const additionalDiscounts = (free_shipping? shipping_cost : 0) + totalDiscount>0? 0 : ((units>=min_qty_to_get_bulk_discount)? (bulk_unit_discount*(def_units)) : 0)
      // const total = subtotal + (free_shipping? 0 : shipping_cost) - totalDiscount - additionalDiscounts; // Calcula el total final después de aplicar descuentos
      const additionalDiscounts = (shipping_type_code_cost ?? 0) + totalDiscount>0? 0 : ((units>=min_qty_to_get_bulk_discount)? (bulk_unit_discount*(def_units)) : 0)
      const total = subtotal + (shipping_type_code_cost ?? 0) - totalDiscount - additionalDiscounts; // Calcula el total final después de aplicar descuentos
      return { subtotal, products_discount: totalDiscount, order_discount: additionalDiscounts, total, shipping_type_code_cost };
  }

  render() {
      const totals = this.calculateTotals();
      const {free_shipping, shipping_cost, bulk_unit_discount, units } = this.props;
      return (
          <div className='PackSelectorSummaryTable'>
              <div className='PackSelectorSummaryTable_item'>
                  <div className='PackSelectorSummaryTable_item_label'>Subtotal del carrito</div>
                  <div className='PackSelectorSummaryTable_item_value'>{numeral(totals.subtotal).format('$0,0[.]00')}</div>
              </div>
              <div className='PackSelectorSummaryTable_item'>
                  <div className='PackSelectorSummaryTable_item_label'>Envio</div>
                  <div className='PackSelectorSummaryTable_item_value'>{numeral(totals.shipping_type_code_cost ?? 0).format('$0,0[.]00')}</div>
              </div>
              {totals.products_discount > 0 &&
                  <div className='PackSelectorSummaryTable_item'>
                      <div className='PackSelectorSummaryTable_item_label'>Descuento en productos 🏷</div>
                      <div style={{color:"red"}} className='PackSelectorSummaryTable_item_value'>{numeral(totals.products_discount).format('$0,0[.]00')}</div>
                  </div>
              }
              {totals.order_discount > 0 &&
                  <div className='PackSelectorSummaryTable_item'>
                      <div className='PackSelectorSummaryTable_item_label'>Descuento en el pedido 🏷</div>
                      <div style={{color:"red"}} className='PackSelectorSummaryTable_item_value'>{numeral(totals.order_discount).format('$0,0[.]00')}</div>
                  </div>
              }

              <div className='PackSelectorSummaryTable_item_total'>
                  <div className='PackSelectorSummaryTable_item_label_total'>Total</div>
                  <div className='PackSelectorSummaryTable_item_value_total'>{numeral(totals.total).format('$0,0[.]00')}</div>
              </div>
          </div>
      )
  }
}
// SPECIAL FOR CARTS




